module.exports = __webpack_public_path__ + "img/SquidGame_Unit_101_0281.0.52459fe0.webp";